// extracted by mini-css-extract-plugin
export default {"BadgeUpgrade":"_BadgeUpgrade--Np_go"};